import React, { Component } from 'react';

class InfoBlock extends Component {

	constructor(props) {
		super(props);

		this._containerStyle = {
			width: this.props.width,
			height: this.props.imageHeight + this.props.infoHeight,
			fontFamily: this.props.fontFamily,
			fontSize: this.props.fontSize,
			display: 'inline-block',
			position: 'relative'
		};

		this._imageStyle = {
			display: 'block',
			width: this.props.width,
			height: this.props.imageHeight,
			borderTopLeftRadius: this.props.unit * 0.15,
			borderTopRightRadius: this.props.unit * 0.15,
			backgroundSize:"cover",
			backgroundRepeat:"no-repeat",
			backgroundPosition:"center"
		};

		this._infoBlockStyle = {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			color: this.props.infoColor,
			backgroundColor: this.props.infoBackgroundColor,
			height: this.props.infoHeight,
			minHeight: this.props.infoHeight,
			borderBottomLeftRadius: this.props.unit * 0.15,
			borderBottomRightRadius: this.props.unit * 0.15,
			width: this.props.width
		}

	}

	render() {
		return (
			<div style={this._containerStyle}>
				{/* <img style={this._imageStyle} src={this.props.imgsrc} alt={name} /> */}
				<div style={{ ...this._imageStyle, backgroundImage: `url(${this.props.imgsrc})` }}/>
				<div style={this._infoBlockStyle}>
					<span style={{ marginLeft: "0.625vh", maxWidth: "78%" }}>
						{this.props.text}
					</span>
					<span style={{ marginRight: "0.625vh" }}>
						<img alt="Forward" src={"/img/tampa/ui/icon-arrow-forward.png"} style={{ display: 'inline-block', textAlign: 'right', width: "1.25vh" }} />
					</span>
				</div>
			</div>
		)
	}
}

module.exports = InfoBlock;



// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/InfoBlockTampa.jsx